import { tagTypeService } from '@core/js/services/tagType.service';
import { CONFIG_TAG_TYPE } from '@interlayer/js/components/system/TagManager/buzz/constants';
import { useActiveTagConfig } from '@interlayer/js/components/system/App/buzz/hooks/useActiveTagConfig';
import { TComponentAppearanceSettingConfig } from '@interlayer/js/components/system/TagManager/buzz/types';

export const ComponentAppearanceSettings = (props: TComponentAppearanceSettingConfig) => {
    useActiveTagConfig(props);

    return null;
};

tagTypeService.registerTagType({ [CONFIG_TAG_TYPE.componentAppearanceSettings]: ComponentAppearanceSettings });
